import axios from "axios";
import { API_BASE_PATH } from "../../environment";

const extractErrorMessage = (error: any) => {
  const detail = error?.response?.data?.detail;
  let details = error?.response?.data?.details;
  const message = error?.response?.data?.message;

  if (typeof details === "string") {
    details = details.replace(/^\d+\s*:\s*/, ""); // strip numeric codes
  }

  return detail || details || message;
};

export const forgotPassword = async (email: string) => {
  try {
    const response = await axios.post(
      `${API_BASE_PATH}/auth/forgot-password`,
      { email },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    const backendMsg = extractErrorMessage(error);
    throw { message: backendMsg };
  }
};

export const resetPassword = async (token: string, newPassword: string) => {
  try {
    const formData = new URLSearchParams();
    formData.append("token", token);
    formData.append("new_password", newPassword);

    const response = await axios.post(
      `${API_BASE_PATH}/auth/reset-password`,
      formData,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
      }
    );

    return response.data;
  } catch (error: any) {
    const backendMsg = extractErrorMessage(error);
    throw { message: backendMsg };
  }
};
